import React from 'react'
import { Button, Container, Row, Col, UncontrolledTooltip } from "reactstrap";
import Clients2 from 'views/index-sections/Clients2';
import Testimonial from 'views/index-sections/Testimonial';

const Clients = () => {
    return (
        <div id="clients-section" style={{
            background: 'linear-gradient(135deg, #7C3AED 0%, #EC4899 100%)',
            padding: '80px 0',
            position: 'relative',
            overflow: 'hidden'
        }}>
            {/* Background decorative elements */}
            <div style={{
                position: 'absolute',
                top: '-50px',
                right: '-50px',
                width: '200px',
                height: '200px',
                background: 'rgba(255,255,255,0.1)',
                borderRadius: '50%',
                zIndex: 1
            }}></div>
            <div style={{
                position: 'absolute',
                bottom: '-100px',
                left: '-100px',
                width: '300px',
                height: '300px',
                background: 'rgba(255,255,255,0.05)',
                borderRadius: '50%',
                zIndex: 1
            }}></div>
            
            <Container style={{ position: 'relative', zIndex: 2 }}>
                {/* Header Section */}
                <div className="text-center" style={{ marginBottom: '60px' }}>
                    <h2 style={{
                        color: 'white',
                        fontSize: '3rem',
                        fontWeight: '700',
                        marginBottom: '20px',
                        textShadow: '0 4px 8px rgba(0,0,0,0.3)'
                    }}>
                        Our Valued Clients
                    </h2>
                    <div style={{
                        width: '80px',
                        height: '4px',
                        background: 'linear-gradient(45deg, #ff6b6b, #feca57)',
                        margin: '0 auto 30px',
                        borderRadius: '2px'
                    }}></div>
                    <p style={{
                        color: 'rgba(255,255,255,0.9)',
                        fontSize: '1.2rem',
                        maxWidth: '600px',
                        margin: '0 auto',
                        lineHeight: '1.6'
                    }}>
                        We're proud to partner with amazing businesses that trust us with their digital success. 
                        Here's what they have to say about working with Tri-Advise.
                    </p>
                </div>

                {/* Client Logos Section */}
                <div style={{ marginBottom: '80px' }}>
                    <h3 style={{
                        color: 'white',
                        textAlign: 'center',
                        marginBottom: '40px',
                        fontSize: '2rem',
                        fontWeight: '600'
                    }}>
                        Trusted by Industry Leaders
                    </h3>
                    <Clients2/>
                </div>

                {/* Testimonials Section */}
                <div style={{ marginBottom: '60px' }}>
                    <h3 style={{
                        color: 'white',
                        textAlign: 'center',
                        marginBottom: '50px',
                        fontSize: '2rem',
                        fontWeight: '600'
                    }}>
                        Client Success Stories
                    </h3>
                    <Testimonial/>
                </div>
{/*
            <Row>
            
              <Col className="mr-auto ml-auto" md="3" sm="4">
                <h3 className="text-center"><b>Saifan</b></h3>
                <br/>
                <img
                  alt="..."
                  className="img-circle img-no-padding img-responsive"
                  src={require("assets/img/faces/saifanlogo.png").default}
                />
              <br/>
              <br/>
                
                <p className="text" style={{color:"black"}}>
                The reason we chose Tri-Advise over other companies was their value for 
                great customer service and their focus on having interactive and engaging
                websites and social media. 
                </p>
              </Col>
              <Col className="mr-auto ml-auto" md="3" sm="4">
              <h3 className="text-center"><b>Evora Fashion</b></h3>
              <br/>
              <img
                alt="..."
                className="img-circle img-no-padding img-responsive"
                src={require("assets/img/faces/evoralogo.jpg").default}
              /> 
              <br/>
              <br/>
              <p className="text" style={{color:"black"}}>
              Greatest appreciation to you and your team for the outstanding job you did for us. We feel privileged to have Tri-Advise as our online marketing partner!              </p>
              </Col>
            <Col className="mr-auto ml-auto" md="3" sm="4">
            <h3 className="text-center"><b>Fitness Garage</b></h3>
            <br/>
            <img
              alt="..."
              className="img-circle img-no-padding img-responsive"
              src={require("assets/img/faces/fitnesslogo1.png").default}
            />    
            <br/>
            <br/>


            <p className="text" style={{color:"black"}}>
            <br/>
            <br/>
            I am very satisfied!  Enjoyable to work with, and most importantly, enabled us to have a strong online presence.            </p>
            </Col>
              
            </Row>

            <Row>
            
              <Col className="mr-auto ml-auto" md="2" sm="3">
                <h3 className="text-center"><b>Tafasil</b></h3>
                <br/>
                <img
                  alt="..."
                  className="img-circle img-no-padding img-responsive"
                  src={require("assets/img/faces/tafasillogo.jpg").default}
                />
              <br/>
                
                <p className="text" style={{color:"black"}}>
                <br/>
            
                Tri-Advise team Communications is attentive, personable, and professional. The team provides great support for my company's needs.
                </p>
              </Col>
              <Col className="mr-auto ml-auto" md="2" sm="3">
              <h3 className="text-center"><b>Health Talks</b></h3>
              <br/>
              <img
                alt="..."
                className="img-circle img-no-padding img-responsive"
                src={require("assets/img/faces/healthlogo.jpg").default}
              /> 
              <br/>
              <br/>
              <p className="text" style={{color:"black"}}>
              The team guidance and advice was invaluable in managing Social media accounts... we were thrilled with the way Tri-advise interacts. Without any hesitation... highly recommended.

              </p>
              </Col>
            <Col className="mr-auto ml-auto" md="2" sm="3">
            <h3 className="text-center"><b>DAB BBQ</b></h3>
            <br/>
            <img
              alt="..."
              className="img-circle img-no-padding img-responsive"
              src={require("assets/img/faces/dablogo.jpg").default}
            />    
            <br/>
            <br/>


            <p className="text" style={{color:"black"}}>
            Always available to answer any questions. Very knowledgeable about the services they provide. Would recommend it to anyone!
            </p>
            </Col>
            <Col className="mr-auto ml-auto" md="2" sm="3">
            <h3 className="text-center"><b>Delora</b></h3>
            <br/>
            <img
              alt="..."
              className="img-circle img-no-padding img-responsive"
              src={require("assets/img/faces/deloralogo.jpg").default}
            />    
            <br/>


            <p className="text" style={{color:"black"}}>
            <br/>
          
            With QR code, it is easy as pie for our clients to scroll our Menu, and who is better than Tri-Advise to do it ? 
            </p>
            </Col>
            </Row>
            <Row>
            <Col className="mr-auto ml-auto" md="2" sm="3">
            <h3 className="text-center"><b>A-LWS</b></h3>
            <br/>
            <img
              alt="..."
              className="img-circle img-no-padding img-responsive"
              src={require("assets/img/faces/awlslogo.jpg").default}
            />    
            <br/>
            <br/>


            <p className="text" style={{color:"black"}}>
            It's always a pleasure to work with Tri-Advise and his team. They are personable, responsive, and results-oriented!
            </p>
            </Col>
            <Col className="mr-auto ml-auto" md="2" sm="3">
            <h3 className="text-center"><b>AbeBarber</b></h3>
            <br/>
            <img
              alt="..."
              className="img-circle img-no-padding img-responsive"
              src={require("assets/img/faces/barberlogo.png").default}
              />    
            <br/>
            <br/>


            <p className="text" style={{color:"black"}}>
            On the social media front, there is no way we would have been able to gain the successes we have had on Facebook, Twitter, and LinkedIn without Tri-Advise.
            </p>
            </Col>
            <Col className="mr-auto ml-auto" md="2" sm="3">
            <h3 className="text-center"><b>IceBit</b></h3>
            <br/>
            <img
              alt="..."
              className="img-circle img-no-padding img-responsive"
              src={require("assets/img/faces/icebitlogo.png").default}
            />    
            <br/>
            <br/>


            <p className="text" style={{color:"black"}}>
            Tri-Advise is a remarkable Digital Marketing Agency.
            </p>
            </Col>
            <Col className="mr-auto ml-auto" md="2" sm="3">
            <h3 className="text-center"><b>GSM</b></h3>
            <br/>
            <img
              alt="..."
              className="img-circle img-no-padding img-responsive"
              src={require("assets/img/faces/gsmlogo.jpg").default}
            />    
            <br/>
            <br/>


            <p className="text" style={{color:"black"}}>
            It is a pleasure working with Tri-Advise. 
            The team is extremely knowledgeable, business savvy, and positive.
            Their approach to challenges and opportunities is innovative. They are highly productive and consistently deliver as promised. 
            And to top it all off, they are gracious, kind, and insightful.            </p>
            </Col>
              
            </Row>
*/}
                {/* Social Media Section */}
                <div className="text-center" style={{ marginTop: '60px' }}>
                    <h3 style={{
                        color: 'white',
                        marginBottom: '30px',
                        fontSize: '1.8rem',
                        fontWeight: '600'
                    }}>
                        Join Our Community
                    </h3>
                    <p style={{
                        color: 'rgba(255,255,255,0.8)',
                        marginBottom: '40px',
                        fontSize: '1.1rem'
                    }}>
                        Follow us for the latest updates and digital marketing insights
                    </p>
                    
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', flexWrap: 'wrap' }}>
                        <Button
                            className="btn-round"
                            style={{
                                background: 'linear-gradient(45deg, #1DA1F2, #0d8bd9)',
                                border: 'none',
                                padding: '12px 24px',
                                borderRadius: '25px',
                                color: 'white',
                                fontWeight: '600',
                                boxShadow: '0 4px 15px rgba(29, 161, 242, 0.3)',
                                transition: 'all 0.3s ease'
                            }}
                            href="https://twitter.com/triadvise"
                            target="_blank"
                            id="tooltip3373767"
                        >
                            <i className="fa fa-twitter" style={{ marginRight: '8px' }} /> Twitter
                        </Button>
                        <UncontrolledTooltip delay={0} target="tooltip3373767">
                            Follow us on Twitter!
                        </UncontrolledTooltip>
                        
                        <Button
                            className="btn-round"
                            style={{
                                background: 'linear-gradient(45deg, #FF0000, #cc0000)',
                                border: 'none',
                                padding: '12px 24px',
                                borderRadius: '25px',
                                color: 'white',
                                fontWeight: '600',
                                boxShadow: '0 4px 15px rgba(255, 0, 0, 0.3)',
                                transition: 'all 0.3s ease'
                            }}
                            href="https://www.youtube.com/channel/UCpxTq-YDUXuEjw97mPtl3Tw"
                            target="_blank"
                            id="tooltip840791273"
                        >
                            <i className="fa fa-youtube-play" style={{ marginRight: '8px' }} /> YouTube
                        </Button>
                        <UncontrolledTooltip delay={0} target="tooltip840791273">
                            Subscribe to our channel!
                        </UncontrolledTooltip>
                        
                        <Button
                            className="btn-round"
                            style={{
                                background: 'linear-gradient(45deg, #4267B2, #365899)',
                                border: 'none',
                                padding: '12px 24px',
                                borderRadius: '25px',
                                color: 'white',
                                fontWeight: '600',
                                boxShadow: '0 4px 15px rgba(66, 103, 178, 0.3)',
                                transition: 'all 0.3s ease'
                            }}
                            href="https://www.facebook.com/TriAdvise/"
                            target="_blank"
                            id="tooltip68961360"
                        >
                            <i className="fa fa-facebook-square" style={{ marginRight: '8px' }} /> Facebook
                        </Button>
                        <UncontrolledTooltip delay={0} target="tooltip68961360">
                            Like our page!
                        </UncontrolledTooltip>
                        
                        <Button
                            className="btn-round"
                            style={{
                                background: 'linear-gradient(45deg, #0077B5, #005885)',
                                border: 'none',
                                padding: '12px 24px',
                                borderRadius: '25px',
                                color: 'white',
                                fontWeight: '600',
                                boxShadow: '0 4px 15px rgba(0, 119, 181, 0.3)',
                                transition: 'all 0.3s ease'
                            }}
                            href="https://www.linkedin.com/company/tri-advise"
                            target="_blank"
                            id="tooltipLinkedIn"
                        >
                            <i className="fa fa-linkedin" style={{ marginRight: '8px' }} /> LinkedIn
                        </Button>
                        <UncontrolledTooltip delay={0} target="tooltipLinkedIn">
                            Connect with us!
                        </UncontrolledTooltip>
                    </div>
                </div>
            </Container>
        </div>
    )
}

export default Clients
